import { Outlet, useLocation } from "react-router-dom";
import { styled } from "@stitches/react";
import { Banner, BannerItem } from "@Forge/dist";
import MainNav from "@components/MainNav";
import { ContextDetails } from "../../../src/types/app-state";

const NavSection = styled("div", {
  paddingLeft: 8,
  paddingRight: 16,
  backgroundColor: "#F3F3F3",
  height: 70,
  marginBottom: 36,
});

const ContextOutputSwitch = ({
  authorizationError,
  context,
}: {
  authorizationError?: string;
  context?: ContextDetails;
}) => {
  const location = useLocation();
  if (location.pathname === "/error") {
    return <Outlet />;
  }
  if (authorizationError) {
    return (
      <Banner alertType="critical">
        <BannerItem headerText="Application Error">
          {authorizationError}
        </BannerItem>
      </Banner>
    );
  }

  if (context?.user)
    return (
      <>
        <NavSection>
          <MainNav />
        </NavSection>
        <Outlet />
      </>
    );

  return null;
};

export default ContextOutputSwitch;
